export default __webpack_public_path__ + "static/media/signup.ab9152e8.png";